/**
 * Mots vides de la saisie : ceux que le serveur ignore en lisant les mots
 * (`MOTS_VIDES`, backend/src/infra/crm_repository/_raison_sociale_vocabulaire.py). Un mot
 * vide n'est pas cherché, il n'est donc pas surligné (« de » dans « Ville de Brest »).
 *
 * Module frère de `highlightMatch.tsx` : une constante exportée À CÔTÉ de fonctions depuis
 * un `.tsx` fait lire tout le module comme un module de composants, et `react-refresh`
 * signale alors chacune de ses fonctions (`--max-warnings 0` : CI rouge).
 */
export const MOTS_VIDES_DE_LA_SAISIE: ReadonlySet<string> = new Set(
    'de du des la le les l d et en au aux a sur sous lez un une the of and'.split(' '),
)
